export const OTO_PLUS_ICON = 'oto_plus';
export const DELETE_CHAT_MODAL_ID = 'deleteChatModal';
export const NOTIFICATION_OPT_OUT = 'notification_op_out';
